document.addEventListener('DOMContentLoaded', (event) => {
  const translations = {
    fr: {
      smart_cart: {
        bmsm_discount_message:
          "Achetez <span class='bmsm-quantity'></span>, économisez <span class='bmsm-discount'></span>",
        cart_title: 'Votre panier de goût',
        checking_out_label: 'Traitement de la commande...',
        checkout_label: 'Passer à la caisse',
        continue_shopping_label: 'Continuer vos achats',
        discount_button_label: 'Carte cadeau ou code promo',
        discount_code_label: 'Carte cadeau ou code promo',
        discount_invalid_message: 'Carte cadeau ou code promo invalide',
        discount_label: 'Carte cadeau ou code promo',
        empty_cart:
          "<h4 class='mb-4'>Votre panier est vide!</h4><a href='/collections/all'>Commencer vos achats</a>",
        free_shipping_reached: '🎉 Félicitations! Vous avez <b>LIVRAISON GRATUITE!</b>',
        free_shipping_remaining:
          "Il ne reste que <span class='helper-shipping'></span> pour <b>la livraison gratuite</b>",
        free_product_tier_remaining:
          "Dépensez <span class='helper-amount'></span> obtenez <span class='helper-product'></span>",
        notes_label: 'Ajouter une note (facultatif)',
        notes_placeholder: 'Écrivez votre note ici',
        notes_remaining_characters: 'Caractères restants',
        subtotal_plural_text: 'Total',
        subtotal_singular_text: 'Total',
        view_cart_label: 'Voir le panier',
        view_cart_working_label: 'Ouverture du panier...',
      },
      widget: {
        add_to_cart: 'Ajouter',
        added_to_cart: 'Ajouté',
        adding_to_cart: 'Ajout au panier',
        cart_switch_to_onetime: "Passer à l'achat unique",
        cart_switch_to_subscription: 'Abonnez-vous et économisez',
        cart_switch_to_subscription_footer: 'Abonnez-vous et économisez',
        continue: 'Continuer',
        decline: 'Refuser',
        delivery_frequency_label: 'Fréquence de livraison',
        learn_more_label: 'En savoir plus',
        remove_body: 'Êtes-vous sûr de vouloir supprimer cet article?',
        remove_confirm: 'Oui, supprimer',
        remove_deny: 'Non, garder',
        remove_from_cart: 'Supprimer du panier',
        remove_title: 'Supprimer cet article',
        removed_from_cart: 'Supprimé',
        removing_from_cart: 'Suppression en cours...',
        sold_out_label: 'Épuisé',
        thank_you_button: 'Merci',
        thank_you_description: 'Merci pour votre achat!',
        thank_you_title: 'Merci!',
        title: 'Découvrez celui-ci...',
        upgrade_to_subscription: "Passer à l'abonnement",
        variant_option: 'Taille',
        variant_options: 'Options',
        total_price_label: 'Votre prix :',
        reviews: 'Avis',
        pay_full_price: 'Payer le plein prix',
        subscribe_and_save_20: 'Abonnez-vous pour économiser 20%',
        one_time_only: 'Une seule fois',
        stock_guaranteed_6_weeks: 'Stock garanti, livraison tous les 6 semaines',
        stock_guaranteed_8_weeks: 'Stock garanti, livraison tous les 8 semaines',
        stock_guaranteed_10_weeks: 'Stock garanti, livraison tous les 10 semaines',
      },
      73936: {
        add_to_cart: 'Ajouter',
        super_title: '',
        title: 'Découvrez plus à aimer',
        description: '',
      },
      99302: {
        add_to_cart: 'Ajouter au panier',
        super_title: '',
        title: 'Bundles Recommandés par des Experts',
        description: '',
        total_price_label: 'Prix du Bundle',
      },
    },
    at: {
      smart_cart: {
        bmsm_discount_message:
          "Kaufe <span class='bmsm-quantity'></span>, spare <span class='bmsm-discount'></span>",
        cart_title: 'Ihr geschmackvoller Warenkorb',
        checking_out_label: 'Bestellung wird bearbeitet...',
        checkout_label: 'Zur Kasse gehen',
        continue_shopping_label: 'Weiter einkaufen',
        discount_button_label: 'Geschenkkarte oder Rabattcode',
        discount_code_label: 'Geschenkkarte oder Rabattcode',
        discount_invalid_message: 'Ungültige Geschenkkarte oder Rabattcode',
        discount_label: 'Geschenkkarte oder Rabattcode',
        empty_cart:
          "<h4 class='mb-4'>Ihr Warenkorb ist leer!</h4><a href='/collections/all'>Einkauf beginnen</a>",
        free_shipping_reached: '🎉 Herzlichen Glückwunsch! Sie haben <b>VERSANDKOSTENFREI!</b>',
        free_shipping_remaining:
          "Nur noch <span class='helper-shipping'></span> bis <b>versandkostenfrei</b>",
        free_product_tier_remaining:
          "Geben Sie <span class='helper-amount'></span> aus und erhalten Sie <span class='helper-product'></span>",
        notes_label: 'Eine Notiz hinzufügen (optional)',
        notes_placeholder: 'Schreiben Sie Ihre Notiz hier',
        notes_remaining_characters: 'Verbleibende Zeichen',
        subtotal_plural_text: 'Gesamt',
        subtotal_singular_text: 'Gesamt',
        view_cart_label: 'Warenkorb ansehen',
        view_cart_working_label: 'Warenkorb wird geöffnet...',
      },
      widget: {
        add_to_cart: 'Hinzufügen',
        added_to_cart: 'Hinzugefügt',
        adding_to_cart: 'Wird dem Warenkorb hinzugefügt',
        cart_switch_to_onetime: 'Einmalig kaufen',
        cart_switch_to_subscription: 'Abonnieren und sparen',
        cart_switch_to_subscription_footer: 'Abonnieren und sparen',
        continue: 'Weiter',
        decline: 'Ablehnen',
        delivery_frequency_label: 'Lieferhäufigkeit',
        learn_more_label: 'Mehr erfahren',
        remove_body: 'Möchten Sie diesen Artikel wirklich entfernen?',
        remove_confirm: 'Ja, entfernen',
        remove_deny: 'Nein, behalten',
        remove_from_cart: 'Aus dem Warenkorb entfernen',
        remove_title: 'Diesen Artikel entfernen',
        removed_from_cart: 'Entfernt',
        removing_from_cart: 'Wird entfernt...',
        sold_out_label: 'Ausverkauft',
        thank_you_button: 'Danke',
        thank_you_description: 'Vielen Dank für Ihren Einkauf!',
        thank_you_title: 'Danke!',
        title: 'Schauen Sie sich das an...',
        upgrade_to_subscription: 'Zum Abonnement wechseln',
        variant_option: 'Größe',
        variant_options: 'Optionen',
        total_price_label: 'Ihr Preis:',
        reviews: 'Bewertungen',
        pay_full_price: 'Vollpreis bezahlen',
        subscribe_and_save_20: 'Abonnieren und 20% sparen',
        one_time_only: 'Nur einmal',
        stock_guaranteed_6_weeks: 'Vorrätig, Lieferung alle 6 Wochen',
        stock_guaranteed_8_weeks: 'Vorrätig, Lieferung alle 8 Wochen',
        stock_guaranteed_10_weeks: 'Vorrätig, Lieferung alle 10 Wochen',
      },
      73936: {
        add_to_cart: 'Hinzufügen',
        super_title: '',
        title: 'Entdecken Sie mehr zum Verlieben',
        description: '',
      },
      99302: {
        add_to_cart: 'In den Warenkorb',
        super_title: '',
        title: 'Expertenempfohlene Bündel',
        description: '',
        total_price_label: 'Bündelpreis',
      },
    },
    de: {
      smart_cart: {
        bmsm_discount_message:
          "Kaufe <span class='bmsm-quantity'></span>, spare <span class='bmsm-discount'></span>",
        cart_title: 'Ihr geschmackvoller Warenkorb',
        checking_out_label: 'Bestellung wird bearbeitet...',
        checkout_label: 'Zur Kasse gehen',
        continue_shopping_label: 'Weiter einkaufen',
        discount_button_label: 'Geschenkkarte oder Rabattcode',
        discount_code_label: 'Geschenkkarte oder Rabattcode',
        discount_invalid_message: 'Ungültige Geschenkkarte oder Rabattcode',
        discount_label: 'Geschenkkarte oder Rabattcode',
        empty_cart:
          "<h4 class='mb-4'>Ihr Warenkorb ist leer!</h4><a href='/collections/all'>Einkauf beginnen</a>",
        free_shipping_reached: '🎉 Herzlichen Glückwunsch! Sie haben <b>VERSANDKOSTENFREI!</b>',
        free_shipping_remaining:
          "Nur noch <span class='helper-shipping'></span> bis <b>versandkostenfrei</b>",
        free_product_tier_remaining:
          "Geben Sie <span class='helper-amount'></span> aus und erhalten Sie <span class='helper-product'></span>",
        notes_label: 'Eine Notiz hinzufügen (optional)',
        notes_placeholder: 'Schreiben Sie Ihre Notiz hier',
        notes_remaining_characters: 'Verbleibende Zeichen',
        subtotal_plural_text: 'Gesamt',
        subtotal_singular_text: 'Gesamt',
        view_cart_label: 'Warenkorb ansehen',
        view_cart_working_label: 'Warenkorb wird geöffnet...',
      },
      widget: {
        add_to_cart: 'Hinzufügen',
        added_to_cart: 'Hinzugefügt',
        adding_to_cart: 'Wird dem Warenkorb hinzugefügt',
        cart_switch_to_onetime: 'Einmalig kaufen',
        cart_switch_to_subscription: 'Abonnieren und sparen',
        cart_switch_to_subscription_footer: 'Abonnieren und sparen',
        continue: 'Weiter',
        decline: 'Ablehnen',
        delivery_frequency_label: 'Lieferhäufigkeit',
        learn_more_label: 'Mehr erfahren',
        remove_body: 'Möchten Sie diesen Artikel wirklich entfernen?',
        remove_confirm: 'Ja, entfernen',
        remove_deny: 'Nein, behalten',
        remove_from_cart: 'Aus dem Warenkorb entfernen',
        remove_title: 'Diesen Artikel entfernen',
        removed_from_cart: 'Entfernt',
        removing_from_cart: 'Wird entfernt...',
        sold_out_label: 'Ausverkauft',
        thank_you_button: 'Danke',
        thank_you_description: 'Vielen Dank für Ihren Einkauf!',
        thank_you_title: 'Danke!',
        title: 'Schauen Sie sich das an...',
        upgrade_to_subscription: 'Zum Abonnement wechseln',
        variant_option: 'Größe',
        variant_options: 'Optionen',
        total_price_label: 'Ihr Preis:',
        reviews: 'Bewertungen',
        pay_full_price: 'Vollpreis bezahlen',
        subscribe_and_save_20: 'Abonnieren und 20% sparen',
        one_time_only: 'Nur einmal',
        stock_guaranteed_6_weeks: 'Vorrätig, Lieferung alle 6 Wochen',
        stock_guaranteed_8_weeks: 'Vorrätig, Lieferung alle 8 Wochen',
        stock_guaranteed_10_weeks: 'Vorrätig, Lieferung alle 10 Wochen',
      },
      73936: {
        add_to_cart: 'Hinzufügen',
        super_title: '',
        title: 'Entdecken Sie mehr zum Verlieben',
        description: '',
      },
      99302: {
        add_to_cart: 'In den Warenkorb',
        super_title: '',
        title: 'Expertenempfohlene Bündel',
        description: '',
        total_price_label: 'Bündelpreis',
      },
    },
    en: {
      smart_cart: {
        bmsm_discount_message:
          "Buy <span class='bmsm-quantity'></span>, save <span class='bmsm-discount'></span>",
        cart_title: 'Your tasteful basket',
        checking_out_label: 'Processing order...',
        checkout_label: 'Go to Checkout',
        continue_shopping_label: 'Continue shopping',
        discount_button_label: 'Gift card or discount code',
        discount_code_label: 'Gift card or discount code',
        discount_invalid_message: 'Invalid gift card or discount code',
        discount_label: 'Gift card or discount code',
        empty_cart:
          '<h4 class="mb-4">Your cart is empty!</h4><a href="/collections/all">Start shopping</a>',
        free_shipping_reached: '🎉 Congratulations! You have <b>FREE SHIPPING!</b>',
        free_shipping_remaining:
          "Only <span class='helper-shipping'></span> left for <b>free shipping</b>",
        free_product_tier_remaining:
          "Spend <span class='helper-amount'></span> get <span class='helper-product'></span>",
        notes_label: 'Add a note (optional)',
        notes_placeholder: 'Write your note here',
        notes_remaining_characters: 'Remaining characters',
        subtotal_plural_text: 'Total',
        subtotal_singular_text: 'Total',
        view_cart_label: 'View cart',
        view_cart_working_label: 'Opening cart...',
      },
      widget: {
        add_to_cart: 'Add',
        added_to_cart: 'Added',
        adding_to_cart: 'Adding to cart',
        cart_switch_to_onetime: 'Switch to one-time',
        cart_switch_to_subscription: 'Subscribe and save',
        cart_switch_to_subscription_footer: 'Subscribe and save',
        continue: 'Continue',
        decline: 'Decline',
        delivery_frequency_label: 'Delivery frequency',
        learn_more_label: 'Learn more',
        remove_body: 'Are you sure you want to remove this item?',
        remove_confirm: 'Yes, remove',
        remove_deny: 'No, keep',
        remove_from_cart: 'Remove from cart',
        remove_title: 'Remove this item',
        removed_from_cart: 'Removed',
        removing_from_cart: 'Removing...',
        sold_out_label: 'Sold out',
        thank_you_button: 'Thank you',
        thank_you_description: 'Thank you for your purchase!',
        thank_you_title: 'Thank you!',
        title: 'Check this one out...',
        upgrade_to_subscription: 'Upgrade to subscription',
        variant_option: 'Size',
        variant_options: 'Options',
        total_price_label: 'Your price:',
        reviews: 'Reviews',
        pay_full_price: 'Pay full price',
        subscribe_and_save_20: 'Subscribe to save 20%',
        one_time_only: 'One-time only',
        stock_guaranteed_6_weeks: 'Stock guaranteed, delivery every 6 weeks',
        stock_guaranteed_8_weeks: 'Stock guaranteed, delivery every 8 weeks',
        stock_guaranteed_10_weeks: 'Stock guaranteed, delivery every 10 weeks',
      },
      73936: {
        add_to_cart: 'Add',
        super_title: '',
        title: 'Discover more to love',
        description: '',
      },
      99302: {
        add_to_cart: 'Add to cart',
        super_title: '',
        title: 'Expert-Recommended Bundles',
        description: '',
        total_price_label: 'Bundle Price',
      },
    },
  };
  const getLocaleFromDomain = () => {
    const { host, pathname } = window.location;
    const subdomain = host.split('.');
    const pathSegments = pathname.split('/').filter(Boolean);

    if (subdomain.includes('be')) {
      if (pathSegments.includes('fr')) {
        return 'fr';
      } else {
        return null;
      }
    } else if (subdomain.includes('fr')) {
      if (pathSegments.includes('fr')) {
        return 'fr';
      } else {
        return null;
      }
    } else {
      return subdomain[subdomain.length - 1];
    }
  };

  updateSmartCartLanguage = () => {
    const locale = getLocaleFromDomain();
    const translation = translations[locale]?.smart_cart;

    if (locale && translation) {
      Object.assign(Rebuy.SmartCart.settings.language, translation);
      if (translations[locale]?.announcement_bar) {
        Object.assign(
          Rebuy.SmartCart.settings.announcement_bar,
          translations[locale].announcement_bar
        );
      }
    }
  };

  updateWidgetLanguage = (widget) => {
    const locale = getLocaleFromDomain();
    const widgetTranslation = translations[locale]?.[widget.id];
    const globalTranslation = translations[locale]?.widget;

    if (locale && widgetTranslation) {
      Object.assign(widget.data.settings.language, widgetTranslation);
      widget.compileConfig();
    } else if (locale && globalTranslation) {
      Object.assign(widget.data.settings.language, globalTranslation);
      widget.compileConfig();
    }
  };

  const updateElementText = (selector, text, replaceText) => {
    const elements = document.querySelectorAll(selector);

    if (elements && text) {
      elements.forEach((el) => {
        if (replaceText) {
          let innerText = el.innerText || el.textContent;
          el.innerHTML = innerText.replace(replaceText, text);
        } else {
          el.innerHTML = text;
        }
      });
    }
  };

  const updateElementAttribute = (selector, attr, value) => {
    const elements = document.querySelectorAll(selector);

    if (elements && attr && value) {
      elements.forEach((el) => {
        el.setAttribute(attr, value);
      });
    }
  };

  const updateDOMText = () => {
    const locale = getLocaleFromDomain();
    updateElementText(
      '.rebuy-cart__flyout-item-subscription button span',
      translations[locale]?.widget?.cart_switch_to_subscription,
      'Upgrade to Subscription & Save'
    );
    updateElementText(
      '.rebuy-bundle__actions-price-label',
      translations[locale]?.widget?.total_price_label
    );
    updateElementText('.rebuy-review-count-label', translations[locale]?.widget?.reviews);

    updateElementAttribute(
      '.rebuy-cart__flyout-item-subscription select optgroup[label="Pay Full Price"]',
      'label',
      translations[locale]?.widget?.pay_full_price
    );
    updateElementAttribute(
      '.rebuy-cart__flyout-item-subscription select optgroup[label^="Subscribe and Save 20%"]',
      'label',
      translations[locale]?.widget?.subscribe_and_save_20
    );

    updateElementText(
      '.rebuy-cart__flyout-item-subscription select option[value="onetime"]',
      translations[locale]?.widget?.one_time_only
    );
    updateElementText(
      '.rebuy-cart__flyout-item-subscription select option[value="Stock guaranteed, ships every 6 weeks"]',
      translations[locale]?.widget?.stock_guaranteed_6_weeks
    );
    updateElementText(
      '.rebuy-cart__flyout-item-subscription select option[value="Stock guaranteed, ships every 8 weeks"]',
      translations[locale]?.widget?.stock_guaranteed_8_weeks
    );
    updateElementText(
      '.rebuy-cart__flyout-item-subscription select option[value="Stock guaranteed, ships every 10 weeks"]',
      translations[locale]?.widget?.stock_guaranteed_10_weeks
    );
  };

  const updateRemaining = () => {
    const locale = getLocaleFromDomain();
    if (translations[locale]) {
      const remainingAmount = document.querySelector(
        '.rebuy-cart__flyout-subtotal-label .item-count'
      );

      if (remainingAmount) {
        remainingAmount.innerHTML = Rebuy.Cart.cart.item_count;
      }

      const tiers = Rebuy.SmartCart?.settings?.buy_more_save_more?.tiers;
      if (tiers) {
        tiers.forEach((tier, index) => {
          if (
            document.querySelectorAll('.rebuy-cart__flyout-item-buy-more-save-more-button').length >
            0
          ) {
            document.querySelectorAll(
              '.rebuy-cart__flyout-item-buy-more-save-more-button .bmsm-discount'
            )[index].innerHTML = tier.discount + '%';
            document.querySelectorAll(
              '.rebuy-cart__flyout-item-buy-more-save-more-button .bmsm-quantity'
            )[index].innerHTML = tier.quantity;
          }
        });
      }

      if (!Rebuy.SmartCart?.progressBar) {
        return;
      }
      const bar = Rebuy.SmartCart.getCurrentTier(Rebuy.SmartCart?.progressBar);
      const barEl = document.getElementById('rebuy-cart__progress-bar-meter-label');
      const helperShipping = barEl.querySelector('.helper-shipping');
      const helperProduct = barEl.querySelector('.helper-product');
      if (bar && barEl) {
        if (bar.type === 'shipping') {
          if (!helperShipping) {
            barEl.innerHTML = translations[locale]?.smart_cart?.free_shipping_remaining;
          }
          barEl.querySelector('.helper-shipping').innerHTML = Rebuy.SmartCart.formatMoney(
            -Math.round(-bar.minimum * 100) - Rebuy.SmartCart.shippingExcludedSubtotal()
          );
        } else {
          if (!helperProduct) {
            barEl.innerHTML = translations[locale]?.smart_cart?.free_product_tier_remaining;
          }
          barEl.querySelector('.helper-amount').innerHTML = Rebuy.SmartCart.formatMoney(
            -Math.round(-bar.minimum * 100) - Rebuy.SmartCart.shippingExcludedSubtotal()
          );
          barEl.querySelector('.helper-product').innerHTML =
            bar.products[0].title ?? 'Produit gratuit';
        }
      }
    }
  };

  // Update Smart Cart with locale translations
  document.addEventListener('rebuy:smartcart.ready', () => {
    updateSmartCartLanguage();
    setTimeout(updateRemaining, 0);
    setTimeout(updateDOMText, 0);
  });

  document.addEventListener('rebuy:cart.change', () => {
    setTimeout(updateRemaining, 0);
    setTimeout(updateDOMText, 0);
  });

  // Update widgets with locale translations
  document.addEventListener('rebuy.ready', (event) => {
    const widget = event.detail.widget;

    updateWidgetLanguage(widget);
    setTimeout(updateRemaining, 0);
    setTimeout(updateDOMText, 0);
  });

  /**
   * Translate the Rebuy widgets with the correct language based on the localisation
   */
  class translateWidgets {
    constructor() {
      // Return if localization object not is found
      if (!localization) {
        return;
      }

      // Return is localization is the primary market
      if (localization.primary) {
        return;
      }

      // Listen for the Rebuy ready event to get the products to translate
      document.addEventListener('rebuy.productsChange', async (e) => {
        const widget = e.detail.widget;
        const products = widget.data.products || [];

        // Return if there are no products
        if (!products.length) {
          return;
        }

        await Promise.all(
          products.map(async (product) => {
            await this.updateProduct(product);
          })
        );

        // Update the widget with thçe new product
        widget.render();
      });
    }

    /**
     * Update the product translation in the Rebuy widget
     * @param {object} product object from Rebuy
     * @returns {void}
     */
    async updateProduct(product) {
      const storefrontHelper = new ShopifyStorefrontHelper();

      try {
        let translation = await this.fetchTranslation(product);
        translation = this.mapTranslation(product, translation);

        if (!translation) {
          return true;
        }

        // Update the product with the new translation
        product.body_html = translation.body_html;
        product.description = translation.description;
        product.handle = translation.handle;
        product.link = translation.link;
        product.product_type = translation.product_type;
        product.title = translation.title;
        product.tags = translation.tags.join(', ');
        product.vendor = translation.vendor;
        product.options = translation.options;
        product.variants = translation.variants;
        product.selected_variant = translation.selected_variant;

        // Update the product JSON with the new translation
        storefrontHelper.updateProductJSON(product);
      } catch (error) {
        console.error(error);
      }
    }

    /**
     * Fetch the product from Shopify by id to use as translation
     * @param {object} product object from Rebuy
     * @returns {object} product object from Shopify
     */
    async fetchTranslation(product) {
      if (!product?.id) {
        return;
      }

      const query = `
        query productDetails @inContext(country: ${localization.country}, language: ${localization.language}) {
          product(id: "gid://shopify/Product/${product.id}") {
            body_html: descriptionHtml
            description
            handle
            link: onlineStoreUrl
            product_type: productType
            title
            tags
            vendor
            options(first: 3) {
              id
              name
              values
            }
            variants(first: 99) {
              nodes {
                id
                title
                price {
                  amount
                }
              }
            }
            selected_variant: selectedOrFirstAvailableVariant {
              id
              title
              price {
                amount
              }
            }
          }
        }
      `;

      const response = await fetch(
        'https://oil-vinegar-store.myshopify.com/api/2024-10/graphql.json',
        {
          async: true,
          crossDomain: true,
          method: 'POST',
          headers: {
            'X-Shopify-Storefront-Access-Token': localization.token,
            'Content-Type': 'application/graphql',
            'Accept-Language': localization.language,
          },
          body: query,
        }
      );

      const data = await response.json();
      const productData = data.data.product;

      return productData;
    }

    /**
     * Map the shopify product object to the Rebuy product object to use as translation
     * @param {*} product object from Rebuy
     * @param {*} translation product object from Shopify
     * @returns
     */
    mapTranslation(product, translation) {
      if (!product?.id || !translation?.title) {
        return;
      }

      // Update the product options to match the Rebuy format
      translation.options = translation.options.map((option, index) => {
        const id = parseInt(option.id.split('/').reverse()[0]);
        return {
          id: id,
          name: option.name,
          position: index + 1,
          product_id: product.id,
          values: option.values,
        };
      });

      // Update the product variants to match the Rebuy format
      translation.variants = translation.variants.nodes.map((variant, index) => {
        const id = parseInt(variant.id.split('/').reverse()[0]);
        const rebuyVariant = product.variants.find((v) => v.id == id);
        rebuyVariant.title = variant.title;
        rebuyVariant.price = variant.price.amount;
        return rebuyVariant;
      });

      // Update the selected variant to match the Rebuy format
      const selectedVariantId = parseInt(translation.selected_variant.id.split('/').reverse()[0]);
      const selectedVariant = translation.variants.find((v) => v.id == selectedVariantId);
      selectedVariant.title = translation.selected_variant.title;
      selectedVariant.price = translation.selected_variant.price.amount;
      translation.selected_variant = selectedVariant;

      // Fill in option1, option2, option3 based on the options
      translation.option1 = translation.options[0]?.name || '';
      translation.option2 = translation.options[1]?.name || '';
      translation.option3 = translation.options[2]?.name || '';

      return translation;
    }
  }
  new translateWidgets();
});
